import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import colorSchemes from '../../../../../styling/theme';
import breakpoints from '../../../../../styling/breakpoints';

const Add = styled.button`
  background: none;
  color: ${colorSchemes.veryDarkSaturatedBlue};
  cursor: pointer;
  &:hover {
    color: ${colorSchemes.primaryButtonColor};
  }
  &:focus {
    outline: none;
  }
  @media ${breakpoints.desktopLg} {
    font-size: 0.85rem;
  }
  @media ${breakpoints.tabletLg} {
    font-size: 0.75rem;
  }
  @media ${breakpoints.tabletSm} {
    font-size: 0.7rem;
  }
  @media ${breakpoints.mobileLg} {
    padding-left: 4px;
  }
`;

const getAddFieldIcon = (circularAddField) =>
  circularAddField
    ? `https://s3-us-west-2.amazonaws.com/media.wisedoc.net/Editor/add_circle.svg`
    : `https://s3-us-west-2.amazonaws.com/media.wisedoc.net/Editor/add_button.svg`;

class AddField extends Component {
  state = {};

  render() {
    const { clickHandle, buttonType, circularAddField } = this.props;
    const src = getAddFieldIcon(circularAddField);
    const alternativeARIA = `ADD ${buttonType}`;
    return (
      <Add type="button" onClick={clickHandle}>
        <img src={src} alt={alternativeARIA} />
      </Add>
    );
  }
}
AddField.propTypes = {
  circularAddField: PropTypes.bool,
  buttonType: PropTypes.string,
  clickHandle: PropTypes.func.isRequired,
};

AddField.defaultProps = {
  circularAddField: false,
  buttonType: '',
};

export default AddField;
